import { permissionsPerRole } from './permissionsPerRole'
import { mapUserRoleToUserRoleInApp } from './roleHelpers'
import AuthService from 'helpers/authService'
import { isProduction, isRelease } from 'helpers/environmentHelpers'

/**
 *
 * @param {string} loggedInUserRole - The role of the current user
 * @param {string[]} requiredPermissions - Permissions required for a React Node
 * @param {boolean} site - If the user is site manager or not
 */
export const checkPermissions = (
  loggedInUserRole,
  requiredPermissions,
  site = false,
) => {
  if (requiredPermissions.length === 0) {
    return true
  }

  const loggedInUserRoleInApp = mapUserRoleToUserRoleInApp(
    loggedInUserRole,
    site,
  )

  // The current role is unknown and does not exist in our permissions file
  if (!permissionsPerRole[loggedInUserRoleInApp]) {
    return false
  }

  return requiredPermissions.every(
    requiredPermission =>
      permissionsPerRole[loggedInUserRoleInApp][requiredPermission],
  )
}

const ACH_PAYMENT_RELEASE_ALLOWED_USER_ID = 8
const ACH_PAYMENT_PRODUCTION_ALLOWED_USER_ID = 170248

/* Function that returns if a user has access to ACH Payment section */
export const ACHPaymentAccessCheck = () => {
  const loggedInUser = AuthService.getLoggedInUser()
  if (!loggedInUser) return false
  if (isRelease()) {
    return ACH_PAYMENT_RELEASE_ALLOWED_USER_ID === loggedInUser.id
  }
  if (isProduction()) {
    return ACH_PAYMENT_PRODUCTION_ALLOWED_USER_ID === loggedInUser.id
  }
  return false
}
